import * as React from 'react';
const SvgTimeline = (props) => (
  <svg viewBox="0 0 106 122" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M87.293 103.178c10.332-10.395 10.332-27.249 0-37.644s-27.083-10.395-37.415 0-10.332 27.249 0 37.644 27.083 10.395 37.415 0ZM54.6 73.707l13.987 10.65M68.586 84.356l10.288-9.416M68.586 58.618v4.706M43.004 84.356h4.677M68.586 110.099v-4.706M94.174 84.356h-4.678"
      stroke="#222221"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.731 47.254h10.412V36.78H10.73v10.475ZM29.127 42.214h34.418M10.731 70.147h10.412V59.672H10.73v10.475ZM29.127 65.106h6.449M10.731 93.036h10.412V82.56H10.73v10.475ZM29.127 88.453h6.449M67.83 9.918h2.924c2.746 0 4.978 2.246 4.978 5.013v32.57"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.056 110.214H6.978c-2.746 0-4.978-2.24-4.978-5.008V14.931c0-2.767 2.232-5.013 4.978-5.013h2.487M58.63 2h-.378c-2.55 0-4.618 2.08-4.618 4.646v6.548c0 2.566 2.067 4.647 4.618 4.647h.378c2.55 0 4.618-2.08 4.618-4.647V6.646C63.248 4.08 61.181 2 58.63 2ZM19.007 2h-.378c-2.55 0-4.618 2.08-4.618 4.646v6.548c0 2.566 2.067 4.647 4.618 4.647h.378c2.55 0 4.618-2.08 4.618-4.647V6.646C23.625 4.08 21.558 2 19.007 2ZM28.584 9.918h20.04"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgTimeline;
